
import { defineAsyncComponent, computed, defineComponent, ref } from "vue";
import AgCard from "@/components/ag-card/index.vue";
import AgOtpModal from "@/components/ag-otp-modal/index.vue";
import ComputerListPage from "@/helpers/pages/ComputerListPage";
import moment from "moment";
import Swal from "sweetalert2";
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useRoute } from "vue-router";
import EventBus from "@/helpers/EventBus";
import { Roles } from "@/helpers/enums/Roles";
import dateOptions from "@/helpers/DateOptions";
import { store } from "@/store";
import router from "./../../../../router";

const ComputerStatus: any = {
  passive: 0,
  active: 1,
  offline: 2,
  all: 3,
};
export default defineComponent({
  name: "ComputerListPage",
  setup() {
    const route = useRoute();
    const module = ref(ComputerListPage);
    const store = useStore();
    const setFilterStatus = () => {
      store.dispatch(GeneralActionTypes.FILTER_STATUS, false);
    };

    const user: any = computed(() => store.getters.loggedInUser);
    const group: any = computed(() => store.getters.group);

    let filter: any = ref({
      page: 1,
      limit: 10,
      ComputerGuid: "",
      os: null,
      agentversion: "",
      policyversion: null,
      activePassiveOrOffline: ComputerStatus.all,
      GroupGuids: [],
      protectionStatusFilter: ""

      // status: route.params.status,
    });

    const RESETFILTER = filter;
    const getList = (
      filters = filter.value,
      options = module.value.component.options
    ) => {
      const body = { filters, options };
      if (route.query.filterStatus) {
        store.dispatch(GeneralActionTypes.FILTER_STATUS, true);
      }
      store.dispatch(GeneralActionTypes.GET_COMPUTER_LIST, body);
    };

    const searchWithFilters = (param: any) => {
      filter.value.ComputerGuid = module.value.filter.filters[1].vmodel || "";
      filter.value.os = module.value.filter.filters[2].vmodel || null;
      filter.value.agentversion = module.value.filter.filters[3].vmodel || "";
      filter.value.protectionStatusFilter = module.value.filter.filters[5].vmodel || "";
      filter.value.policyversion =
        module.value.filter.filters[4].vmodel || null;
      filter.value.GroupGuids = module.value.filter.filters[0].vmodel;

      module.value.filter.filters.forEach((element: any) => {
        if (element.requestKey) {
          filter.value[element.requestKey] = element.vmodel;
        }
      });

      const filters = filter.value;
      const options = module.value.component.options;
      options.page = 1;
      module.value.readyToUseFilters = filters;
      if (!param) {
        router.push({ query: { searchResults: "true" } });
      }
      getList(filters, options);
    };

    const resetFilters = () => {
      module.value.filter.filters.forEach((item: any) => {
          item.vmodel = null;
      });

      let query = Object.assign({}, router.currentRoute.value.query);
      delete query.searchResults;
      router.replace({ query });
      searchWithFilters(true);
    };

    const deleteFunction = function (id: any) {
      Swal.fire({
        title: "Delete Computer?",
        icon: "warning",
        text: "You are about to delete the selected computer. Do you want to delete ?",
        showCancelButton: true,
        confirmButtonText: "Delete",
      }).then((result) => {
        if (result.isConfirmed) {
          store
            .dispatch(GeneralActionTypes.DELETE_ASSET_COMPUTERS, id)
            .then((response) => {
              if (response.isSuccess) {
                getList();
              }
              if (Number(response.statusCode) != 200) {
                Swal.fire("Error", response.Errors, "error");
              } else {
                Swal.fire(
                  "Deleted!",
                  "The Computer has been deleted.",
                  "success"
                );
              }
            })
            .catch((e) => {
              Swal.fire("Error", JSON.stringify(e.Message), "error");
            });
        }
      });
    };
    return {
      setFilterStatus,
      searchWithFilters,
      resetFilters,
      deleteFunction,
      filter,
      getList,
      module,
    };
  },
  data() {
    return {
      otpStatus: false,
      loading: false,
      tempData: {
        total: 0,
        rows: [],
      },
      selectedComputer: {
        ComputerId: "",
      },
    };
  },
  computed: {
    statusParam(): any {
      return this.$route.params.status;
    },
  },
  methods: {
    mainLink() {
      if (this.tempData.total > 0) {
        this.module.component.options.rows = this.tempData.rows;
        this.module.component.options.total = this.tempData.total;
      } else {
        const filters = this.filter;
        this.module.readyToUseFilters = filters;
        const options = this.module.component.options;
        this.getList(filters, options);
      }
    },
    search() {
      this.tempData.rows = this.module.component.options.rows;
      this.tempData.total = this.module.component.options.total;
      this.module.component.options.rows = [];
      this.module.component.options.total = 0;
    },
    otpFunction(data: any) {
      this.otpStatus = true;
      this.selectedComputer = data;
    },
    loadFiltersIfExist() {
      this.module.filter.filters.forEach((item) => {
        item.vmodel = null;
      });
      let data: any = this.$route.params.data;
      if (data != undefined) {
        data = JSON.parse(data);
        data.forEach((item: any) => {
          this.filter[item.name] = item.value;
          this.module.filter.filters.forEach((filter: any) => {
            if (filter.apiEquivalent == item.name) {
              filter.selectedLabel = item.selectedLabel;
              filter.vmodel = item.value;
              return;
            }
          });
        });
      }
    },
    loadFilters(data: any) {
      this.module.filter.filters.forEach((item) => {
        item.vmodel = null;
      });
      if (data != undefined) {
        data = JSON.parse(data);
        data.forEach((item: any) => {
          this.filter[item.name] = item.value;
          this.module.filter.filters.forEach((filter: any) => {
            if (filter.apiEquivalent == item.name) {
              filter.selectedLabel = item.selectedLabel;
              filter.vmodel = item.value;
              return;
            }
          });
        });
      }
    },
  },
  mounted() {
    EventBus.on("computerLoad", (data: any) => {
      this.loadFilters(data);
      const filters = this.filter;
      this.module.readyToUseFilters = filters;
      const options = this.module.component.options;
      this.getList(filters, options);
    });
    this.setFilterStatus();
    const filters = this.filter;
    this.filter.activePassiveOrOffline = ComputerStatus[this.statusParam];
    this.module.readyToUseFilters = filters;
    const options = this.module.component.options;
    this.getList(filters, options);
  },
  components: { AgCard, AgOtpModal },
});
